<template>
  <el-dialog :visible="visible" :title="dialogTitle" @close="handleCancel" :close-on-click-modal="false" width="800px">
    <div v-loading="loading">
      <el-radio-group v-model="postData.Type" size="medium" style="margin-bottom: 10px; width: 100%" @input="changeType">
        <el-radio-button label="item">商品</el-radio-button>
        <el-radio-button :disabled="form.SpecQty == 0" label="spec">规格</el-radio-button>
        <el-radio-button label="level_price">等级价格</el-radio-button>
        <el-radio-button label="special">限时特价</el-radio-button>
        <el-radio-button :disabled="form.SpecQty == 0" label="special_spec">特殊规格</el-radio-button>
        <el-radio-button :disabled="form.SpecQty == 0 || colors.length == 0" label="color">颜色映射</el-radio-button>
      </el-radio-group>
      <el-form id="item" label-width="100px" label-position="right" v-if="postData.Type == 'item'" label-suffix="：" :inline="true">
        <el-form-item label="温馨提示" v-if="form.SpecQty > 0">
          <div style="color: red; width: 500px">特殊颜色/尺码，请切换到【特殊规格】处理</div>
        </el-form-item>
        <el-row :gutter="0">
          <el-col :span="16">
            <el-form-item label="货号" prop="ItemNo">
              <el-input v-model="form.ProPrice.ItemNo" placeholder="请输入货号" :disabled="form.ProductID > 0" style="width: 250px" />
              <el-popover style="margin-left: 10px" placement="bottom" trigger="click" ref="popover" @after-leave="handlePopoverClose">
                <el-input
                  type="textarea"
                  v-model="analyseContent"
                  :placeholder="'请输入商品内容，示例：\n【货号】C103\n【颜色】卡其色，米色\n【尺码】35-40 \n【价格】39'"
                  :autosize="{ minRows: 10 }"
                />
                <el-button type="primary" :loading="analyseLoading" style="float: right; margin-top: 10px" @click="handleAnalyse">
                  解析
                </el-button>
                <el-button type="primary" slot="reference">一键解析</el-button>
              </el-popover>
            </el-form-item>
            <el-form-item label="商品价" prop="Price">
              <el-input v-if="$store.state.routes.systemSetting.IsHideProductPriceAuth" value="**" disabled style="width: 250px" />
              <el-input v-else v-model="form.ProPrice.Price" v-format.float placeholder="请输入商品价" style="width: 250px" />
              元
            </el-form-item>
            <el-form-item label="采购价" prop="Cost">
              <el-input v-if="$store.state.routes.systemSetting.IsHideCostPriceAuth" value="**" disabled style="width: 250px" />
              <el-input v-else v-model="form.ProPrice.Cost" v-format.float placeholder="请输入采购价" style="width: 250px" />
              元
            </el-form-item>
            <el-form-item label="客户价" prop="SettlePrice" v-if="form.IncludeSettle">
              <el-select
                v-model="form.ProPrice.SettleType"
                :disabled="$store.state.routes.systemSetting.IsHideCustomerPriceAuth"
                style="width: 85px; margin-right: 5px"
              >
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-input v-if="$store.state.routes.systemSetting.IsHideCustomerPriceAuth" value="**" disabled style="width: 160px" />
              <el-input
                v-else
                v-model="form.ProPrice.SettlePrice"
                v-format.float
                :placeholder="
                  form.ProPrice.SettleType == 0
                    ? Number(form.ProPrice.Price - form.Discount) > 0
                      ? form.ProPrice.Price - form.Discount
                      : 0
                    : '请输入优惠金额'
                "
                style="width: 160px"
              />
              元
            </el-form-item>
            <el-form-item label="供应商">
              <el-autocomplete
                placeholder="供应商"
                v-model="form.DefaultSupplierName"
                style="width: 250px"
                :fetch-suggestions="loadSuppliers"
              />
            </el-form-item>
            <el-form-item label="货架" prop="Shelves">
              <el-input v-model="form.Shelves" placeholder="请输入货架" style="width: 250px" />
            </el-form-item>
          </el-col>
          <el-col :span="8" style="text-align: right">
            <el-upload
              ref="uploadImage"
              class="avatar-uploader"
              accept="image/*"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :on-success="uploadImgSuccess"
              :on-error="uploadImgError"
            >
              <img v-if="form.DefaultImage" :src="form.DefaultImage" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-col>
        </el-row>
        <el-form-item label="颜色">
          <dynamic-tags
            style="width: 610px"
            v-model="itemColors"
            title="添加颜色"
            :exten="{ visable: false }"
            @valueChange="colorsChange"
          />
        </el-form-item>
        <el-form-item label="尺码">
          <dynamic-tags
            style="width: 610px"
            v-model="itemSizes"
            title="添加尺码"
            :exten="{ visable: true, title: '选择尺码' }"
            @valueChange="sizesChange"
          />
        </el-form-item>
        <el-form-item label="货号映射">
          <dynamic-tags
            style="width: 610px"
            v-model="itemNos"
            title="添加新别称"
            :exten="{ visable: false }"
            @valueChange="itemNosChange"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="form.IsOnSale"
            active-color="#409EFF"
            active-text="在售中"
            inactive-color="#ff4949"
            inactive-text="已下架"
            :active-value="0"
            :inactive-value="1"
            @change="handleProductStatusChange"
          ></el-switch>
        </el-form-item>
      </el-form>
      <el-table
        :data="form.Specs"
        :key="listKey"
        v-if="postData.Type == 'spec'"
        border
        :span-method="objectSpanMethod"
        class="black-border-table"
      >
        <el-table-column prop="Color" label="颜色" show-overflow-tooltip align="center">
          <template slot-scope="{ row }">
            {{ row.Color }}
            <br />
            <template v-if="form.IsOnSale == 0">
              <el-link
                type="primary"
                style="margin-right: 10px"
                @click="handleSpecsStatusChange(null, row.Color, 0)"
                v-if="checkSpecsColor(row.Color, 1)"
              >
                全部上架
              </el-link>
              <el-link type="primary" @click="handleSpecsStatusChange(null, row.Color, 1)" v-if="checkSpecsColor(row.Color, 0)">
                全部下架
              </el-link>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="Size" label="尺码" show-overflow-tooltip align="center" />
        <el-table-column label="条码" show-overflow-tooltip width="200px" align="center">
          <template slot="header">
            <span>条码</span>
            <el-link type="primary" style="margin-left: 8px; font-size: 12px" @click="handleBarcodeSetting">批量设置</el-link>
          </template>
          <template slot-scope="{ row }">
            <el-input v-model="row.Barcode" placeholder="" size="small" />
          </template>
        </el-table-column>
        <el-table-column prop="IsOnSale" label="状态" align="center">
          <template slot-scope="{ row }">
            <template v-if="form.IsOnSale == 0">
              <span :class="row.IsOnSale == 0 ? '' : 'red'">{{ row.IsOnSale == 0 ? '在售' : '下架' }}</span>
            </template>
            <template v-else><span class="red">下架</span></template>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90" align="center" v-if="form.IsOnSale == 0">
          <template slot-scope="{ row }">
            <el-link type="primary" v-if="row.IsOnSale != 0" @click="handleSpecsStatusChange(row.SpecID, null, 0)"> 上架 </el-link>
            <el-link type="primary" v-if="row.IsOnSale == 0" @click="handleSpecsStatusChange(row.SpecID, null, 1)"> 下架 </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-form
        id="level_price"
        label-width="120px"
        label-position="right"
        v-if="postData.Type == 'level_price'"
        label-suffix="："
        :inline="true"
      >
        <el-form-item label="温馨提示">
          <span style="color: red">
            设置不同等级的价格，请先开启客户等级，
            <a href="/#/stall/purchaser" target="_blank">前往设置>></a>
          </span>
        </el-form-item>
        <el-form-item v-for="(level, index) in levelPrices" :key="index" :label="level.label + '价格'">
          <el-select
            v-model="level.type"
            :disabled="$store.state.routes.systemSetting.IsHideCustomerPriceAuth"
            style="width: 85px; margin-right: 5px"
          >
            <el-option v-for="item in levelPriceOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input v-if="$store.state.routes.systemSetting.IsHideCustomerPriceAuth" value="**" disabled style="width: 250px"></el-input>
          <el-input v-else v-model="level.price" v-format.float :placeholder="form.ProPrice.Price" style="width: 250px" />
          元
        </el-form-item>
      </el-form>
      <el-form
        id="special_spec"
        :inline="true"
        :label-width="postData.Type == 'color' ? '120px' : '100px'"
        label-position="right"
        label-suffix="："
        v-if="postData.Type != 'item' && postData.Type != 'spec' && postData.Type != 'level_price'"
      >
        <el-form-item label="温馨提示" v-if="postData.Type == 'special_spec'">
          <span style="color: red">无需特殊配置的价格，放空即可；特殊规格删除时【所有客户】客户价都会删除</span>
        </el-form-item>
        <el-form-item :label="'新增' + (postData.Type == 'color' ? '颜色映射' : '价格')">
          <el-checkbox v-model="isCustom" v-if="postData.Type == 'special_spec'" style="margin-right: 5px"> 自定义 </el-checkbox>
          <el-input
            v-if="postData.Type == 'special_spec' && isCustom && colors.length > 0"
            v-model="customColor"
            class="customInput"
            placeholder="输入颜色"
          />
          <el-input
            v-if="postData.Type == 'special_spec' && isCustom && sizes.length > 0"
            v-model="customSize"
            class="customInput"
            placeholder="输入尺码"
          />
          <el-select
            class="colorSelect"
            placeholder="选择颜色"
            v-model="newColor"
            multiple
            collapse-tags
            v-if="((postData.Type == 'special_spec' && !isCustom) || postData.Type != 'special_spec') && colors.length > 0"
            @change="handleSelectChanged('color')"
          >
            <el-option v-for="item in colors" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <el-select
            class="sizeSelect"
            style="margin-left: 3px"
            placeholder="选择尺码"
            v-model="newSize"
            multiple
            collapse-tags
            v-if="
              ((postData.Type == 'special_spec' && !isCustom) || postData.Type != 'special_spec') &&
              postData.Type != 'color' &&
              sizes.length > 0
            "
            @change="handleSelectChanged('size')"
          >
            <el-option v-for="item in sizes" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <el-tooltip class="item" effect="dark" content="商品价" placement="bottom">
            <el-input
              v-if="postData.Type != 'color'"
              v-model="newProPrice"
              v-format.float
              class="newPrice"
              :placeholder="form.ProPrice.Price"
            />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="采购价" placement="bottom">
            <el-input
              v-if="postData.Type != 'color'"
              v-model="newProCost"
              v-format.float
              class="newPrice"
              :placeholder="form.ProPrice.Cost"
            />
          </el-tooltip>
          <el-date-picker
            v-if="postData.Type == 'special'"
            v-model="timeRangeValue"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 200px; margin-left: 3px"
          />
          <el-button
            type="primary"
            plain
            :disabled="
              postData.Type != 'color' &&
              ($store.state.routes.systemSetting.IsHideProductPriceAuth ||
                $store.state.routes.systemSetting.IsHideCostPriceAuth ||
                (postData.Type == 'special_spec' && form.IncludeSettle && $store.state.routes.systemSetting.IsHideCustomerPriceAuth))
            "
            style="margin-left: 3px; margin-top: -3px"
            @click="addItem"
          >
            新增
          </el-button>
          <el-button
            v-if="postData.Type == 'special_spec'"
            type="danger"
            plain
            :disabled="
              $store.state.routes.systemSetting.IsHideProductPriceAuth ||
              $store.state.routes.systemSetting.IsHideCostPriceAuth ||
              (form.IncludeSettle && $store.state.routes.systemSetting.IsHideCustomerPriceAuth)
            "
            style="float: right; margin-left: 5px"
            @click="clearItem"
          >
            清空全部
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="proSpecialPrices"
        :key="listKey"
        v-if="postData.Type == 'special'"
        :cell-class-name="handleCellClassName"
        :row-class-name="handleRowClassName"
      >
        <el-table-column prop="Color" label="颜色" width="120" show-overflow-tooltip align="center" v-if="colors.length > 0" />
        <!--价格配置Start-->
        <el-table-column prop="Size" label="尺码" width="100" show-overflow-tooltip align="center" v-if="sizes.length > 0" />
        <el-table-column prop="Price" label="商品价" align="center">
          <template slot-scope="{ row }">
            <el-input v-if="$store.state.routes.systemSetting.IsHideProductPriceAuth" value="**" disabled style="width: 70px" />
            <el-input v-else v-model="row.Price" v-format.float :placeholder="form.ProPrice.Price" style="width: 70px" />
            元
          </template>
        </el-table-column>
        <el-table-column prop="Cost" label="采购价" align="center">
          <template slot-scope="{ row }">
            <el-input v-if="$store.state.routes.systemSetting.IsHideCostPriceAuth" value="**" disabled style="width: 70px" />
            <el-input v-else v-model="row.Cost" v-format.float :placeholder="form.ProPrice.Cost" style="width: 70px" />
            元
          </template>
        </el-table-column>
        <el-table-column prop="TimeRange" label="限时" width="230" align="center">
          <template slot-scope="{ row }">
            {{ row.TimeRange ? row.TimeRange : '-' }}
          </template>
        </el-table-column>
        <!--价格配置End-->
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="{ row, $index }">
            <el-button type="text" icon="el-icon-delete" style="color: red" @click="delItem(row, $index)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        :data="form.Prices"
        :key="listKey"
        v-if="form.SpecQty > 0 && postData.Type == 'special_spec'"
        :cell-class-name="handleCellClassName"
        :row-class-name="handleRowClassName"
      >
        <el-table-column prop="Color" label="颜色" width="120" show-overflow-tooltip align="center" v-if="colors.length > 0">
          <template slot-scope="{ row }">
            <span v-if="row.IsCustom == 1">
              {{ row.Color ? '含：“' + row.Color + '”' : '' }}
            </span>
            <span v-else>
              {{ row.Color }}
            </span>
          </template>
        </el-table-column>
        <!--价格配置Start-->
        <el-table-column prop="Size" label="尺码" width="100" show-overflow-tooltip align="center" v-if="sizes.length > 0">
          <template slot-scope="{ row }">
            <span v-if="row.IsCustom == 1">
              {{ row.Size ? '含：“' + row.Size + '”' : '' }}
            </span>
            <span v-else>
              {{ row.Size }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="Price" label="商品价" align="center">
          <template slot-scope="{ row }">
            <el-input v-if="$store.state.routes.systemSetting.IsHideProductPriceAuth" value="**" disabled style="width: 70px" />
            <el-input v-else v-model="row.Price" v-format.float :placeholder="form.ProPrice.Price" style="width: 70px" />
            元
          </template>
        </el-table-column>
        <el-table-column prop="Cost" label="采购价" align="center">
          <template slot-scope="{ row }">
            <el-input v-if="$store.state.routes.systemSetting.IsHideCostPriceAuth" value="**" disabled style="width: 70px" />
            <el-input v-else v-model="row.Cost" v-format.float :placeholder="form.ProPrice.Cost" style="width: 70px" />
            元
          </template>
        </el-table-column>
        <el-table-column prop="SettlePrice" label="客户价" width="180" v-if="form.IncludeSettle" align="center">
          <template slot-scope="{ row }">
            <el-select v-model="row.SettleType" :disabled="$store.state.routes.systemSetting.IsHideCustomerPriceAuth" style="width: 85px">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-input v-if="$store.state.routes.systemSetting.IsHideCustomerPriceAuth" value="**" disabled style="width: 70px"></el-input>
            <el-input
              v-else
              v-model="row.SettlePrice"
              v-format.float
              :placeholder="row.SettleType == 0 ? (Number(row.Price - form.Discount) > 0 ? row.Price - form.Discount : 0) : ''"
              style="width: 50px; margin-left: 3px"
            />
            元
          </template>
        </el-table-column>
        <!--价格配置End-->
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="{ row, $index }">
            <el-button
              type="text"
              icon="el-icon-delete"
              :disabled="
                $store.state.routes.systemSetting.IsHideProductPriceAuth ||
                $store.state.routes.systemSetting.IsHideCostPriceAuth ||
                (form.IncludeSettle && $store.state.routes.systemSetting.IsHideCustomerPriceAuth)
              "
              style="color: red"
              @click="delItem(row, $index)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        :data="form.ColorMappings"
        :key="listKey"
        v-if="form.SpecQty > 0 && postData.Type == 'color'"
        :cell-class-name="handleCellClassName"
        :row-class-name="handleRowClassName"
      >
        <el-table-column prop="Color" label="特殊颜色" width="120" show-overflow-tooltip align="center" v-if="colors.length > 0" />
        <!--颜色映射Start-->
        <el-table-column label="别称">
          <template slot-scope="{ row, $index }">
            <el-tag v-for="(rename, index) in row.RenameList" :key="index" closable type="warning" @close="delRename(row, index)">
              {{ rename }}
            </el-tag>
            <el-input
              v-if="editIndex == $index"
              v-model.trim="newRename"
              ref="renameInput"
              class="input-new-name"
              size="small"
              @change="addRename(row)"
              @blur="addRename(row)"
            />
            <el-button v-else class="button-new-name" size="small" @click="editIndex = $index">添加新别称</el-button>
          </template>
        </el-table-column>
        <!--颜色映射End-->
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{ row, $index }">
            <el-button type="text" icon="el-icon-delete" style="color: red" @click="delItem(row, $index)"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 条码批量设置弹窗 -->
    <el-dialog :visible.sync="barcodeSettingVisible" title="条码批量设置" :close-on-click-modal="false" width="700px" append-to-body>
      <div>
        <div class="barcode-rule-tip">
          <span class="tip-label">生成规则：</span>
          <div class="tip-content">
            <p>1.前缀+货号+中间码+颜色编码+后缀+尺码</p>
            <p>2.前缀/中间码/后缀为非必填项，留空则不拼接；颜色编码为必填项</p>
          </div>
        </div>
        <div class="barcode-section-title">条码规则配置</div>
        <div class="barcode-rule-row">
          <span class="barcode-label">前缀</span>
          <el-input v-model="barcodeSettingData.prefix" placeholder="选填" class="barcode-input" />
          <span class="barcode-plus">+</span>
          <span class="barcode-label">货号</span>
          <el-input v-model="barcodeSettingData.itemNo" disabled class="barcode-input" />
          <span class="barcode-plus">+</span>
          <span class="barcode-label">中间码</span>
          <el-input v-model="barcodeSettingData.middleCode" placeholder="选填" class="barcode-input" />
          <span class="barcode-plus">+</span>
        </div>
        <div class="barcode-rule-row">
          <span class="barcode-label">颜色编码</span>
          <el-input placeholder="下方设置" disabled class="barcode-input" />
          <span class="barcode-plus">+</span>
          <span class="barcode-label">后缀</span>
          <el-input v-model="barcodeSettingData.suffix" placeholder="选填" class="barcode-input" />
          <span class="barcode-plus">+</span>
          <span class="barcode-label">尺码</span>
          <el-input placeholder="自动" disabled class="barcode-input" />
        </div>
        <div class="barcode-section-title">颜色编码批量配置</div>
        <div class="barcode-color-config">
          <div v-for="(color, index) in barcodeSettingData.colors" :key="index" class="barcode-color-item">
            <span class="barcode-color-label">{{ color }}</span>
            <el-input
              v-model="barcodeSettingData.colorCodes[index]"
              placeholder="请输入编码（必填）"
              class="barcode-color-input"
              :class="{ 'is-error': barcodeColorErrors[index] }"
            />
            <span v-if="barcodeColorErrors[index]" class="barcode-color-error">{{ barcodeColorErrors[index] }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="barcodeSettingVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBarcodeConfirm">保存并生成条码</el-button>
      </div>
    </el-dialog>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSave">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { submit } from '@/api/base'
import DynamicTags from './Tags.vue'
import { baseURL, successCode } from '@/config'
export default {
  name: 'ProductSetting',
  components: {
    DynamicTags,
  },
  data() {
    return {
      loading: false,
      postData: {},
      uploadUrl: baseURL + '/api/base/file/uploadImg?path=product',
      headers: {
        Authorization: 'Bearer ' + this.$store.getters['user/accessToken'],
      },
      form: {
        SpecQty: 2,
        ProductID: 0,
        PurchaserID: '',
        PurchaserName: '',
        IncludeSettle: false,
        Colors: '',
        Sizes: '',
        IsOnSale: 0,
        ProPrice: {},
        Prices: [],
        ColorMappings: [],
        Specs: [],
        DefaultImage: '',
        DefaultSupplierName: '',
        DefaultSupplier: 0,
        ItemNoMapping: {
          Renames: '',
        },
        Discount: 0,
      },
      proSpecialPrices: [],
      options: [
        { value: 0, label: '固定价' },
        { value: 1, label: '便宜' },
      ],
      itemColors: [],
      itemSizes: [],
      listKey: '',
      visible: false,
      dialogTitle: '编辑',
      isCustom: false,
      customColor: '',
      customSize: '',
      newColor: [],
      newSize: [],
      newProPrice: null,
      newProCost: null,
      editIndex: -1,
      newRename: '',
      timeRangeValue: [],
      itemNos: [],
      mergeObj: {}, // 用来记录需要合并行的下标
      mergeArr: ['Color'], // 表格中的列名
      suppliers: [],
      levelPrices: [],
      levelPriceOptions: [
        // 等级价格类型选项
        { value: 0, label: '固定价' },
        { value: 1, label: '便宜' },
      ],
      analyseLoading: false,
      analyseContent: '',
      barcodeSettingVisible: false,
      barcodeSettingData: {
        prefix: '',
        middleCode: '',
        suffix: '',
        itemNo: '',
        colorCodes: [],
        colors: [],
        sizes: [],
      },
      barcodePreviewList: [],
      barcodeColorErrors: [],
      barcodeLoading: false,
    }
  },
  computed: {
    colors() {
      if (this.form.Colors) {
        let list = this.form.Colors.split(',').sort()
        if (this.form.SpecQty > 1 && this.postData.Type != 'color') {
          list.unshift('全部')
        }
        return list
      }
      return []
    },
    sizes() {
      if (this.form.Sizes) {
        let list = this.form.Sizes.split(',').sort()
        if (this.form.SpecQty > 1) {
          list.unshift('全部')
        }
        return list
      }
      return []
    },
  },
  mounted() {
    this.analyseContent = ''
    this.$nextTick(async () => {
      this.fetchSuppliers()
    })
  },
  methods: {
    handlePopoverClose() {
      // 或者简单直接清空：this.analyseContent = '';
      if (this.analyseContent) {
        this.analyseContent = ''
      }
    },
    async handleAnalyse() {
      this.analyseLoading = true
      let that = this
      let inputStr = that.analyseContent
      const regex = /^\s*[(（【[{]?\s*([^)）】}\]:：\s]+)\s*[)）】\]]?\s*[:：]?\s*([^\n]+)/gm

      let match
      while ((match = regex.exec(inputStr)) !== null) {
        if (!match[1]) {
          break
        }
        const key = match[1].trim()
        // 处理值：去除首尾空白，如果是逗号分隔的尝试转为数组（可选）
        let value = match[2].trim()

        const lowerKey = key.toLowerCase()
        let standardKey = key

        // 简单的映射示例
        if (['货号', 'itemno', 'item_no', '编号'].includes(lowerKey)) standardKey = '货号'
        else if (['颜色', 'color', 'colour'].includes(lowerKey)) standardKey = '颜色'
        else if (['尺码', 'size', 'sku'].includes(lowerKey)) standardKey = '尺码'
        else if (['价格', 'price'].includes(lowerKey)) standardKey = '价格'

        switch (standardKey) {
          case '货号': {
            if (that.form.ProductID > 0) {
              if (that.form.ProPrice.ItemNo != value) {
                that.$baseMessage('输入的货号错误，请确认', 'error')
                this.analyseLoading = false
                return
              }
            } else {
              that.form.ProPrice.ItemNo = value
            }
            break
          }
          case '尺码': {
            // 特殊处理：如果值包含逗号，且你希望它是数组（如颜色、尺码）
            if (value.includes('，') || value.includes(',') || value.includes(' ') || value.includes('　')) {
              value = value.split(/[,，\s]+/).map(item => item.trim())
              that.itemSizes = value
            } else if (value.includes('-')) {
              let sizeArr = value.split('-')
              let itemSizes = []
              let startSize = parseInt(sizeArr[0])
              if (sizeArr.length == 2) {
                let endSize = parseInt(sizeArr[1])
                for (var k = 0; k <= endSize - startSize; k++) {
                  let sizeNew = startSize + k
                  itemSizes.push(sizeNew)
                }
              } else {
                itemSizes.push(startSize)
              }
              that.itemSizes = itemSizes
            }

            that.form.Sizes = that.itemSizes.join(',')
            that.generateSpecs()
            break
          }
          case '价格': {
            that.form.ProPrice.Price = value
            break
          }

          case '颜色': {
            // 特殊处理：如果值包含逗号，且你希望它是数组（如颜色、尺码）
            value = value.split(/[,，\s]+/).map(item => item.trim())
            that.itemColors = value
            that.form.Colors = that.itemColors.join(',')
            that.generateSpecs()
            break
          }
        }
      }
      that.analyseContent = ''
      that.$refs.popover.doClose()
      that.analyseLoading = false
    },
    async fetchSuppliers() {
      const { data } = await submit('/api/purchase/supplier/getList', {
        CurrentPage: 1,
        PageSize: 10000,
      })
      data.datas.forEach(element => {
        element.value = element.SupplierName
      })
      this.suppliers = data.datas || []
    },
    createFilter(qs) {
      return supplier => {
        return supplier.value.toLowerCase().includes(qs.toLowerCase())
      }
    },
    async loadSuppliers(qs, cb) {
      const suppliers = this.suppliers
      var results = qs ? suppliers.filter(this.createFilter(qs)) : suppliers
      cb(results || [])
    },
    uploadImgSuccess(response) {
      if (successCode.includes(response.code)) {
        this.form.DefaultImage = response.data
      } else {
        this.$message({
          type: 'error',
          message: response.msg,
        })
      }
    },
    uploadImgError() {
      this.$message({
        type: 'error',
        message: '上传失败',
      })
    },
    handleProductStatusChange(newVal) {
      var that = this
      if (newVal == 0) {
        that
          .$confirm(`确定要重新上架货品：${that.form.ProPrice.ItemNo}?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            that.form.IsOnSale = 0
            that.form.Specs.forEach((item, index) => {
              item.IsOnSale = 0
            })
          })
          .catch(() => {
            that.$nextTick(() => {
              that.form.IsOnSale = 1
            })
          })
      } else {
        that
          .$confirm(`确定要下架货品：${that.form.ProPrice.ItemNo}?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            that.form.IsOnSale = 1
          })
          .catch(() => {
            that.$nextTick(() => {
              that.form.IsOnSale = 0
            })
          })
      }
    },
    handleSpecsStatusChange(specID, color, isOnSale) {
      this.form.Specs.forEach((item, index) => {
        if (specID != null && item.SpecID == specID) {
          item.IsOnSale = isOnSale
        } else if (color != null && item.Color == color) {
          item.IsOnSale = isOnSale
        }
      })
    },
    checkSpecsColor(color, isOnSale) {
      return this.form.Specs.some(x => x.Color == color && x.IsOnSale == isOnSale)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'Color') {
        if (this.mergeArr[rowIndex]) {
          return [this.mergeArr[rowIndex], 1]
        } else {
          return [0, 0]
        }
      }
    },
    getSpanArr() {
      let that = this
      let itemIndex = 0
      that.mergeArr = []
      that.form.Specs.forEach((item, index) => {
        if (index === 0 || (index > 0 && item.Color != that.form.Specs[index - 1].Color)) {
          itemIndex = index
          that.mergeArr.push(1)
        } else {
          that.mergeArr[itemIndex] += 1
          that.mergeArr.push(0)
        }
      })
    },
    generateSpecs() {
      if (this.form.Colors && this.form.Sizes) {
        this.form.SpecQty = 2
      } else if (this.form.Colors || this.form.Sizes) {
        this.form.SpecQty = 1
      } else {
        this.form.SpecQty = 0
      }
      var that = this
      var list = []
      var colorList = that.form.Colors.split(',').sort()
      var sizeList = that.form.Sizes.split(',').sort()
      colorList.forEach(x => {
        sizeList.forEach(y => {
          // 以 SpecName 精确匹配已有规格行（与后端规格命名一致），保留其 Barcode/SpecID/状态等数据；
          // 不能依赖只读 Color/Size 解析字段，非纯数字尺码等情况下解析结果可能与选中名称不一致，
          // 会把已存在（含条码）的规格行当成新行重建导致条码被清空
          var specName = x + '-' + y
          var filters = that.form.Specs.filter(t => t.SpecName === specName)
          if (filters.length > 0) {
            list.push(filters[0])
          } else {
            list.push({
              ProductID: that.form.ProductID,
              SpecName: specName,
              Color: x,
              Size: y,
              IsOnSale: that.form.IsOnSale,
            })
          }
        })
      })
      that.form.Specs = list
      that.getSpanArr()
    },
    colorsChange() {
      this.form.Colors = this.itemColors.join(',')
      this.generateSpecs()
    },
    sizesChange() {
      this.itemSizes = this.itemSizes.sort(function (a, b) {
        if (a !== b) return a < b ? -1 : 1
        return 0
      })
      this.form.Sizes = this.itemSizes.join(',')
      this.generateSpecs()
    },
    handleSelectChanged(type) {
      if (this.postData.Type != 'color') {
        var dataList = (type == 'color' ? this.colors : this.sizes).filter(x => x != '全部')
        var valueList = type == 'color' ? this.newColor : this.newSize
        var hasAll = valueList.some(x => x == '全部')
        if (hasAll || (!hasAll && valueList.length == dataList.length)) {
          this.$nextTick(() => {
            if (type == 'color') {
              this.newColor = ['全部']
            } else {
              this.newSize = ['全部']
            }
          })
        }
      }
    },
    itemNosChange() {
      this.form.ItemNoMapping.Renames = this.itemNos.join(',')
    },
    async open(postData) {
      var that = this
      that.handleCancel()
      that.postData = postData
      that.dialogTitle = `新增商品`
      // 获取等级配置
      try {
        const res = await submit('/api/common/getCustomerParameter?key=PurchaserLevels')
        if (res.success && res.data) {
          const levelConfig = JSON.parse(res.data)
          that.initLevelPrices(levelConfig)
          if (that.form.LevelPrices) {
            that.levelPrices.forEach(level => {
              const savedLevel = that.form.LevelPrices.find(l => l.level === level.level)
              if (savedLevel) {
                level.price = savedLevel.price
                level.type = savedLevel.type || 0
              }
            })
          }
        }
      } catch (error) {
        console.error('获取等级配置失败', error)
      }
      if (postData.ProductID > 0) {
        that.dialogTitle = `商品编辑`
        let { data } = await submit('/api/product/getProductSetting', this.postData)
        that.form = data
        // 初始化等级价格
        if (that.form.LevelPrices && that.form.LevelPrices.length > 0) {
          if (that.levelPrices.length > 0) {
            that.levelPrices.forEach(level => {
              const savedLevel = that.form.LevelPrices.find(l => l.LevelCode === level.level)
              if (savedLevel) {
                level.price = savedLevel.LevelPrice
                level.type = savedLevel.LevelPriceType || 0
              }
            })
          }
        }
      } else {
        that.form.SpecQty = 0
      }
      that.form.TradeIDs = postData.TradeIDs ? postData.TradeIDs : ''
      if (this.form.ProPrice.SettlePrice == null) {
        this.form.ProPrice.SettleType = 0
      }
      that.form.ColorMappings.forEach(color => {
        color.RenameList = color.Renames.split(',')
        if (!color.RenameList[0]) {
          color.RenameList.splice(0, 1)
        }
      })
      if (typeof that.form.ItemNoMapping != 'undefined' && that.form.ItemNoMapping.Renames != '') {
        that.itemNos = that.form.ItemNoMapping.Renames.split(',')
      }
      that.form.Prices.forEach(price => {
        if (price.PriceID == 0) {
          price.Price = that.form.ProPrice.Price
          price.Cost = that.form.ProPrice.Cost
        }
      })
      that.proSpecialPrices = that.form.Prices.filter(x => (x.TimeRange ?? '') != '')
      that.form.Prices = that.form.Prices.filter(x => (x.TimeRange ?? '') == '')
      that.itemColors = that.form.Colors ? that.form.Colors.split(',') : []
      that.itemSizes = that.form.Sizes ? that.form.Sizes.split(',') : []
      that.getSpanArr()
      that.changeType()
      that.visible = true
    },
    async changeType() {
      let title = this.postData.ProductID > 0 ? '编辑商品' : '新增商品'
      switch (this.postData.Type) {
        case 'item':
          this.dialogTitle = title
          break
        case 'spec':
          this.dialogTitle = `${title}-规格`
          break
        case 'special':
          this.dialogTitle = `${title}-限时特价`
          break
        case 'special_spec':
          this.dialogTitle = `${title}-特殊规格`
          break
        case 'color':
          this.dialogTitle = `${title}-颜色映射`
          break
        case 'level_price':
          this.dialogTitle = `${title}-等级价格`
          // 重置表单时保留已设置的等级价格
          if (this.form.LevelPrices) {
            this.levelPrices.forEach(level => {
              const savedLevel = this.form.LevelPrices.find(l => l.level === level.level)
              if (savedLevel) {
                level.price = savedLevel.price
                level.type = savedLevel.LevelPriceType || 0
              }
            })
          }
          break
      }
      this.listKey = Math.random()
      this.customColor = ''
      this.customSize = ''
      this.newColor = []
      this.newSize = []
      this.newProPrice = null
      this.newProCost = null
      this.timeRangeValue = []
    },
    initLevelPrices(levelConfig) {
      this.levelPrices = []
      for (const [levelKey, levelName] of Object.entries(levelConfig)) {
        this.levelPrices.push({
          level: levelKey,
          label: levelName,
          price: null,
          enabled: true,
          type: 0, // 价格类型，0：固定价，1：便宜
        })
      }
      this.levelPrices.sort((a, b) => {
        const numA = parseInt(a.level.replace('level', ''))
        const numB = parseInt(b.level.replace('level', ''))
        return numA - numB
      })
    },
    handleRowClassName({ row }) {
      if (row.IsDelete) {
        return 'hidden'
      }
      return ''
    },
    handleCellClassName({ row, column }) {
      if (['Color', 'Size'].includes(column.property)) {
        return 'mark'
      }
      return ''
    },
    async addItem() {
      var that = this
      let addData = {
        ProductID: that.form.ProductID,
      }
      let colorList = []
      let sizeList = []
      let existsList = []
      let successCount = 0
      switch (that.postData.Type) {
        case 'special':
          if (that.timeRangeValue.length <= 0) {
            that.$baseMessage('限时特价时间范围不能为空', 'error')
            return
          }
          colorList = that.newColor.length <= 0 ? ['全部'] : that.newColor
          sizeList = that.newSize.length <= 0 ? ['全部'] : that.newSize
          addData.Price = that.newProPrice == null ? '' : that.newProPrice
          addData.Cost = that.newProCost == null ? '' : that.newProCost
          addData.SettlePrice = ''
          addData.TimeRange = that.timeRangeValue.join('至')
          colorList.forEach(x => {
            sizeList.forEach(y => {
              if (that.proSpecialPrices.filter(t => t.Color == x && t.Size == y && t.TimeRange == addData.TimeRange).length > 0) {
                existsList.push(x + '-' + y + '-' + addData.TimeRange)
              } else {
                let item = { ...addData }
                item.Color = x
                item.Size = y
                that.proSpecialPrices.push(item)
                successCount++
              }
            })
          })
          break
        case 'special_spec':
          addData.Price = that.newProPrice == null ? '' : that.newProPrice
          addData.Cost = that.newProCost == null ? '' : that.newProCost
          addData.SettlePrice = ''
          if (that.form.IncludeSettle) {
            addData.PurchaserID = that.postData.PurchaserID
            addData.PurchaserName = that.postData.PurchaserName
          }
          if (that.isCustom) {
            if (that.form.SpecQty == 1) {
              if ((that.colors.length > 0 && that.customColor == '') || (that.sizes.length > 0 && that.customSize == '')) {
                that.$baseMessage(`请输入${that.colors.length > 0 ? '颜色' : '尺码'}`, 'error')
                return
              }
            } else {
              if (that.customColor == '' && that.customSize == '') {
                that.$baseMessage('颜色尺码至少输入一个', 'error')
                return
              }
            }
            if (that.form.Prices.filter(t => t.Color == that.customColor && t.Size == that.customSize).length > 0) {
              existsList.push(that.customColor + '-' + that.customSize)
            } else {
              let item = { ...addData }
              item.IsCustom = 1
              item.Color = that.customColor
              item.Size = that.customSize
              that.form.Prices.push(item)
              successCount++
            }
          } else {
            if (that.form.SpecQty == 1) {
              if ((that.colors.length > 0 && that.newColor.length <= 0) || (that.sizes.length > 0 && that.newSize.length <= 0)) {
                that.$baseMessage(`请选择${that.colors.length > 0 ? '颜色' : '尺码'}`, 'error')
                return
              }
            } else {
              if (
                (that.newColor.length <= 0 || that.newColor.some(x => x == '全部')) &&
                (that.newSize.length <= 0 || that.newSize.some(x => x == '全部'))
              ) {
                that.$baseMessage('颜色尺码至少选择一个', 'error')
                return
              }
            }
            colorList = that.newColor.length <= 0 ? ['全部'] : that.newColor
            sizeList = that.newSize.length <= 0 ? ['全部'] : that.newSize
            colorList.forEach(x => {
              sizeList.forEach(y => {
                if (that.form.Prices.filter(t => t.Color == x && t.Size == y).length > 0) {
                  existsList.push(x + '-' + y)
                } else {
                  let item = { ...addData }
                  item.Color = x
                  item.Size = y
                  that.form.Prices.push(item)
                  successCount++
                }
              })
            })
          }
          break
        case 'color':
          if (that.newColor.length <= 0) {
            this.$baseMessage('请选择颜色', 'error')
            return
          }
          that.newColor.forEach(x => {
            if (that.form.ColorMappings.filter(t => t.Color == x).length > 0) {
              existsList.push(x)
            } else {
              let item = { ...addData }
              item.Color = x
              item.Renames = ''
              item.RenameList = []
              that.form.ColorMappings.push(item)
              successCount++
            }
          })
          break
      }
      if (existsList.length > 0) {
        if (successCount > 0) {
          that.$baseMessage('跳过已存在的配置【' + existsList.join('、') + '】', 'warning')
        } else {
          that.$baseMessage('已存在的配置【' + existsList.join('、') + '】，不可重复添加', 'error')
        }
      }
      that.timeRangeValue = []
      that.newSize = []
      that.newColor = []
      that.customColor = ''
      that.customSize = ''
    },
    clearItem() {
      switch (this.postData.Type) {
        case 'special':
          if (this.proSpecialPrices.length == 0) {
            return
          }
          for (let index = this.proSpecialPrices.length - 1; index >= 0; index--) {
            this.delItem(this.proSpecialPrices[index], index)
          }
          break
        case 'special_spec':
          if (this.form.Prices.length == 0) {
            return
          }
          for (let index = this.form.Prices.length; index >= 0; index--) {
            this.delItem(this.form.Prices[index], index)
          }
          break
      }
    },
    async delItem(row, index) {
      switch (this.postData.Type) {
        case 'special':
          if (row.PriceID > 0) {
            this.proSpecialPrices[index].IsDelete = true
          } else {
            this.proSpecialPrices.splice(index, 1)
          }
          break
        case 'special_spec':
          if (row.PriceID > 0 || row.ID > 0) {
            this.form.Prices[index].IsDelete = true
          } else {
            this.form.Prices.splice(index, 1)
          }
          break
        case 'color':
          if (row.ID > 0) {
            this.form.ColorMappings[index].IsDelete = true
          } else {
            this.form.ColorMappings.splice(index, 1)
          }
          break
      }
      this.listKey = Math.random()
    },
    addRename(row) {
      if (this.newRename == '') {
        return
      }
      row.RenameList.push(this.newRename)
      row.Renames = row.RenameList.join(',')
      this.newRename = ''
      this.editIndex = -1
    },
    delRename(row, rIndex) {
      row.RenameList.splice(rIndex, 1)
      row.Renames = row.RenameList.join(',')
      this.listKey = Math.random()
    },
    handleCancel() {
      this.visible = false
      this.postData = {}
      this.form = {
        SpecQty: 2,
        ProductID: 0,
        PurchaserID: '',
        PurchaserName: '',
        IncludeSettle: false,
        Colors: '',
        Sizes: '',
        IsOnSale: 0,
        ProPrice: {},
        Prices: [],
        ColorMappings: [],
        Specs: [],
        DefaultImage: '',
        DefaultSupplierName: '',
        DefaultSupplier: 0,
        ItemNoMapping: {
          Renames: '',
        },
        Discount: 0,
      }
      this.newColor = ''
      this.newSize = ''
      this.editIndex = -1
      this.newRename = ''
      this.itemNos = []
    },
    async handleBarcodeSetting() {
      // 读取条码配置
      try {
        const res = await submit('/api/common/getCustomerParameter?key=BarCodeCreateSetting')
        if (res.success && res.data) {
          const config = JSON.parse(res.data)
          this.barcodeSettingData.prefix = config.prefix || ''
          this.barcodeSettingData.middleCode = config.middleCode || ''
          this.barcodeSettingData.suffix = config.suffix || ''
        } else {
          this.barcodeSettingData.prefix = ''
          this.barcodeSettingData.middleCode = ''
          this.barcodeSettingData.suffix = ''
        }
      } catch (error) {
        console.error('获取条码配置失败', error)
        this.barcodeSettingData.prefix = ''
        this.barcodeSettingData.middleCode = ''
        this.barcodeSettingData.suffix = ''
      }
      this.barcodeSettingData.itemNo = this.form.ProPrice.ItemNo || ''
      this.barcodeSettingData.colors = this.form.Colors ? this.form.Colors.split(',').sort() : []
      this.barcodeSettingData.sizes = this.form.Sizes ? this.form.Sizes.split(',').sort() : []
      this.barcodeSettingData.colorCodes = this.barcodeSettingData.colors.map(() => '')
      this.barcodePreviewList = []
      this.barcodeColorErrors = []
      this.barcodeSettingVisible = true
    },
    handleBarcodeGenerate() {
      const { prefix, middleCode, suffix, itemNo, colors, sizes, colorCodes } = this.barcodeSettingData
      // 校验颜色编码：必填 + 不可重复
      const errors = colors.map(() => '')
      let hasError = false
      colors.forEach((_, ci) => {
        if (!colorCodes[ci] || !colorCodes[ci].trim()) {
          errors[ci] = '必填'
          hasError = true
        }
      })
      // 检查重复
      if (!hasError) {
        const seen = {}
        colors.forEach((_, ci) => {
          const code = colorCodes[ci].trim()
          if (seen[code] !== undefined) {
            errors[ci] = '重复'
            errors[seen[code]] = '重复'
            hasError = true
          } else {
            seen[code] = ci
          }
        })
      }
      this.barcodeColorErrors = errors
      if (hasError) {
        this.barcodePreviewList = []
        return
      }
      const list = []
      colors.forEach((color, ci) => {
        sizes.forEach((size, si) => {
          const colorCode = colorCodes[ci] || ''
          const barcode = [prefix, itemNo, middleCode, colorCode, suffix, size].filter(Boolean).join('')
          list.push({
            Color: color,
            Size: size,
            Barcode: barcode,
            colorIndex: ci,
            sizeIndex: si,
          })
        })
      })
      this.barcodePreviewList = list
    },
    // 条码确认
    async handleBarcodeConfirm() {
      // 先生成条码
      this.handleBarcodeGenerate()
      if (this.barcodePreviewList.length === 0) {
        this.$message.warning('无可生成的条码')
        return
      }
      // 保存前缀、中间码、后缀配置到数据库
      try {
        await submit('/api/common/updateCustomerParameter', {
          key: 'BarCodeCreateSetting',
          label: '条码生成配置',
          value: JSON.stringify({
            prefix: this.barcodeSettingData.prefix || '',
            middleCode: this.barcodeSettingData.middleCode || '',
            suffix: this.barcodeSettingData.suffix || '',
          }),
        })
      } catch (e) {
        console.error('保存条码配置失败', e)
      }
      // 检查是否有已有条码需要覆盖
      const hasExistingBarcode = this.form.Specs.some(s => s.Barcode)
      if (hasExistingBarcode) {
        this.$confirm('已有部分条码存在，是否覆盖已有条码？', '提示', {
          confirmButtonText: '是（覆盖）',
          cancelButtonText: '否（保留旧条码）',
          type: 'warning',
        })
          .then(() => {
            // 用户选择"是（覆盖）"：新条码覆盖所有已有条码
            this.applyBarcodes(true)
          })
          .catch(action => {
            // 用户选择"否（保留旧条码）"：已有条码保留，新生成的条码写入空白规格行
            if (action === 'cancel') {
              this.applyBarcodes(false)
            } else {
              // 直接关闭弹窗：不应用本次生成
              this.$message.info('已取消')
            }
          })
      } else {
        this.applyBarcodes(true)
      }
    },
    applyBarcodes(overwrite) {
      // 先根据当前商品的颜色尺码重新生成完整规格列表
      const colorList = this.form.Colors ? this.form.Colors.split(',').sort() : []
      const sizeList = this.form.Sizes ? this.form.Sizes.split(',').sort() : []
      const newSpecs = []
      colorList.forEach(color => {
        sizeList.forEach(size => {
          // 按 SpecName（与后端规格一致）匹配已有规格行，保留其 SpecID/Sku/Barcode 等数据；
          // 避免依赖只读 Color/Size 解析字段（非纯数字尺码等会解析不一致）把已有行当新行重建
          const specName = color + '-' + size
          const existingSpec = this.form.Specs.find(s => s.SpecName === specName)
          if (existingSpec) {
            // 查找预览中对应条码
            const preview = this.barcodePreviewList.find(p => p.Color === color && p.Size === size)
            if (preview) {
              if (overwrite || !existingSpec.Barcode) {
                existingSpec.Barcode = preview.Barcode
              }
            }
            newSpecs.push(existingSpec)
          } else {
            // 新规格：查找预览中对应条码
            const preview = this.barcodePreviewList.find(p => p.Color === color && p.Size === size)
            newSpecs.push({
              ProductID: this.form.ProductID,
              SpecName: specName,
              Color: color,
              Size: size,
              IsOnSale: this.form.IsOnSale,
              Barcode: preview ? preview.Barcode : '',
            })
          }
        })
      })
      this.form.Specs = newSpecs
      this.getSpanArr()
      this.barcodeSettingVisible = false
      this.$message.success('条码设置完成')
      this.listKey = Math.random()
    },
    async handleSave() {
      if (this.loading) {
        return
      }
      this.loading = true
      var data = JSON.parse(JSON.stringify(this.form))
      if (!data.ProPrice.ItemNo) {
        this.loading = false
        this.$message.error('货号格式不正确')
        return
      }
      const proPrice = Number(data.ProPrice.Price)
      if (isNaN(proPrice) || proPrice <= 0) {
        this.loading = false
        this.$message.error('商品价不能小于等于0')
        return
      }
      const proSettlePrice = Number(data.ProPrice.SettlePrice)
      if (!data.ProPrice.SettlePrice || proSettlePrice < 0 || (data.ProPrice.SettleType == 1 && proSettlePrice == 0)) {
        data.ProPrice.IsDelete = true
      } else if ((data.ProPrice.SettleType == 0 && proSettlePrice < 0) || (data.ProPrice.SettleType == 1 && proSettlePrice >= proPrice)) {
        this.loading = false
        this.$message.error('商品客户价不能小于0')
        return
      }
      if (data.Shelves && data.Shelves.length > 8) {
        this.loading = false
        this.$message.error('架位长度超过8位')
        return
      }
      let errors = []
      this.proSpecialPrices.forEach(price => {
        if (!price.Price) {
          price.Price = data.ProPrice.Price
        }
        if (!price.Cost) {
          price.Cost = data.ProPrice.Cost
        }
        const specialPrice = Number(price.Price)
        if (isNaN(specialPrice) || specialPrice <= 0) {
          errors.push(`商品限时特价${price.Color}-${price.Size}商品价不能小于等于0`)
        }
        if (!price.SettlePrice) {
          price.SettlePrice = null
        }
      })
      data.Prices.forEach(price => {
        if (!price.Price) {
          price.Price = data.ProPrice.Price
        }
        if (!price.Cost) {
          price.Cost = data.ProPrice.Cost
        }
        const specPrice = Number(price.Price)
        if (isNaN(specPrice) || specPrice <= 0) {
          errors.push(`${price.Color}-${price.Size}商品价不能小于等于0`)
        }
        const specSettlePrice = Number(price.SettlePrice)
        if (!price.SettlePrice || specSettlePrice < 0 || (price.SettleType == 1 && specSettlePrice == 0)) {
          price.SettlePrice = null
        } else if ((price.SettleType == 0 && specSettlePrice < 0) || (price.SettleType == 1 && specSettlePrice >= specPrice)) {
          errors.push(`${price.Color}-${price.Size}商品客户价不能小于0`)
        }
      })

      if (errors.length > 0) {
        this.loading = false
        this.$message.error(errors.join('\r\n'))
        return
      }

      // 条码重复校验
      if (data.Specs && data.Specs.length > 0) {
        const barcodeList = data.Specs.filter(s => s.Barcode && s.Barcode.trim() !== '').map(s => s.Barcode.trim())
        if (barcodeList.length > 1) {
          const duplicateSet = []
          const seen = new Set()
          barcodeList.forEach(b => {
            if (seen.has(b) && !duplicateSet.includes(b)) {
              duplicateSet.push(b)
            }
            seen.add(b)
          })
          if (duplicateSet.length > 0) {
            this.loading = false
            this.$message.error(`规格条码存在重复：${duplicateSet.join('、')}`)
            return
          }
        }
      }

      // 等级价格验证
      const levelPriceErrors = []
      this.levelPrices.forEach(level => {
        if (level.price && Number(level.price) <= 0) {
          levelPriceErrors.push(`${level.label}价格不能小于0`)
        }
        if (level.price && level.type === 1 && Number(level.price) >= Number(this.form.ProPrice.Price)) {
          levelPriceErrors.push(`${level.label}的优惠金额必须小于商品价`)
        }
      })

      if (levelPriceErrors.length > 0) {
        this.loading = false
        this.$message.error(levelPriceErrors.join('\r\n'))
        return
      }

      // 将等级价格数据添加到提交数据中
      data.LevelPrices = this.levelPrices
        .filter(level => level.price) // 只保存有价格的等级
        .map(level => ({
          LevelCode: level.level,
          LevelName: level.label,
          LevelPrice: level.price,
          LevelPriceType: level.type,
        }))
      if (data.LevelPrices.length == 0) {
        data.LevelPrices = null
      }

      data.Prices = [...this.proSpecialPrices, ...data.Prices]
      let rsp = await submit('/api/product/saveProductSetting', data)
      this.loading = false
      if (!rsp.data.success) {
        this.$message.error(rsp.data.msg)
        return
      }
      this.$emit('handleSearch')
      this.handleCancel()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .black-border-table {
    border-top: 1px solid #c3c6cc !important;
    border-left: 1px solid #c3c6cc !important;
    border-right: 1px solid #c3c6cc !important;

    th,
    td {
      border-bottom: 1px solid #c3c6cc !important;
      border-right: 1px solid #c3c6cc !important;
    }

    &::before {
      background-color: #c3c6cc !important;
    }
  }
}

::v-deep {
  .el-dialog {
    max-height: 750px !important;
  }

  .el-dialog__body {
    max-height: 600px !important;
  }

  .el-dialog__body .el-form-item .el-input {
    max-width: inherit !important;
  }

  .el-checkbox__label {
    padding-left: 5px;
  }

  .el-radio-button {
    width: 15%;

    .el-radio-button__inner {
      width: 100%;
    }
  }

  .el-form-item__error {
    display: contents;
  }

  .el-table__row {
    font-size: 14px;

    .mark {
      & > div {
        color: #409eff !important;
      }
    }

    &.hidden {
      display: none;
    }

    .el-table__cell {
      padding: 5px 0;
      vertical-align: middle;
    }
  }

  .el-tag {
    font-size: 14px;
    min-height: 30px;
    height: auto;
    line-height: 30px;
    margin: 2px !important;

    vertical-align: middle;
  }

  .el-select {
    width: 120px;
  }

  .el-range-editor.el-input__inner {
    padding: 2px 10px;
  }

  .el-date-editor .el-range-input {
    width: 72px;
  }
}

#special_spec {
  ::v-deep {
    .el-tag {
      min-height: 25px;
      line-height: 25px;
    }
  }
}

.input-new-name {
  width: 100px;

  ::v-deep {
    .el-input__inner {
      height: 35px !important;
      padding-left: 5px;
    }
  }
}

.button-new-name {
  line-height: 35px;
  padding-top: 0;
  padding-bottom: 0;
}

.colorSelect,
.sizeSelect {
  ::v-deep .el-tag {
    &:nth-last-child(2):first-child {
      max-width: 45px;
    }

    margin: 1px 0px 1px 1px !important;
  }
}

.customInput {
  width: 120px;
  margin-left: 3px;
}

.newPrice {
  width: 55px;
  margin-left: 3px;

  ::v-deep {
    .el-input__inner {
      text-align: center;
      padding: 0 5px;
    }
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;

  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar {
  width: auto;
  max-height: 150px;
  display: block;
}

.barcode-rule-tip {
  display: flex;
  align-items: flex-start;
  background-color: #f5f7fa;
  padding: 12px 15px;
  border-radius: 4px;
  margin-bottom: 15px;
}

.tip-label {
  color: #606266;
  font-size: 14px;
  white-space: nowrap;
  margin-right: 8px;
  line-height: 1.8;
}

.tip-content {
  color: #909399;
  font-size: 13px;
  line-height: 1.8;
}

.tip-content p {
  margin: 0;
}

.barcode-section-title {
  font-size: 15px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 12px;
  padding-left: 5px;
  border-left: 3px solid #409eff;
}

.barcode-rule-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.barcode-label {
  font-size: 14px;
  color: #606266;
  margin-right: 5px;
}

.barcode-input {
  width: 100px;
}

.barcode-input ::v-deep .el-input__inner {
  text-align: center;
}

.barcode-plus {
  font-size: 14px;
  color: #606266;
  margin: 0 8px;
}

.barcode-color-config {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.barcode-color-item {
  display: flex;
  align-items: center;
}

.barcode-color-label {
  display: inline-block;
  width: 50px;
  font-size: 14px;
  color: #606266;
  text-align: right;
  margin-right: 8px;
}

.barcode-color-input {
  width: 140px;
}
.barcode-color-input.is-error > .el-input__inner {
  border-color: #f56c6c;
}
.barcode-color-error {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 6px;
}
</style>
